import CouplesLocationSharingHero from './components/CouplesLocationSharingHero';
import Features from '../../components/sharedComponents/Features';
import HowItWorks from "../../components/sharedComponents/HowItWorks";
import WhyDtp from "../../components/sharedComponents/WhyDtp";
import Testimonials from "../../components/sharedComponents/Testimonials";
import { Helmet } from 'react-helmet';
import { bottomCouplesLocationSharingFeatures } from './data/bottomCouplesLocationSharingFeatures';
import { couplesLocationSharingTestimonials } from "./data/couplesLocationSharingTestimonials";
import { couplesLoactionFeaturesList } from './data/couplesLoactionFeaturesList';

const CouplesLocationSharing = () => {
    return (
        <>
            <Helmet>
                <title>Location Sharing App for Couples - Device Tracker Plus</title>
                <meta name="description" content="Stay close no matter the distance. Share your location, message, and check in with your partner. Built on trust, not surveillance." />
                <link rel="canonical" href="https://www.devicetrackerplus.com/couples-location-sharing" />
            </Helmet>
            <CouplesLocationSharingHero />
            <Features sectionTitle="Features Designed for Couples" features={couplesLoactionFeaturesList} />
            <HowItWorks stepOne="Sign up online" stepTwo="Register device" stepThree="Start Tracking" />
            <Testimonials testimonials={couplesLocationSharingTestimonials} />
            <WhyDtp reasons={bottomCouplesLocationSharingFeatures} title="Why Couples Love Device Tracker Plus"/>

        </>
    );
}

export default CouplesLocationSharing;